import * as actions from "./actions";
import * as financingActions from "../actions";

import _ from "underscore";

let initialState = {
  financings: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },

  financingsIssued: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },

  financingsReady: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },
};

const mplFinancing = (state = initialState, action) => {
  switch (action.type) {
    // GET FINANCINGS
    case financingActions.FINANCINGS_LIST_GET_REQUEST:
      if (action.financingType == "Issued") {
        return Object.assign({}, state, {
          financingsIssued: Object.assign({}, state.financingsIssued, {
            fetching: true,
            error: null,
            data: [],
          }),
        });
      } else if (action.financingType == "Ready") {
        return Object.assign({}, state, {
          financingsReady: Object.assign({}, state.financingsReady, {
            fetching: true,
            error: null,
            data: [],
          }),
        });
      } else {
        return Object.assign({}, state, {
          financings: Object.assign({}, state.financings, {
            fetching: true,
            error: null,
            data: [],
          }),
        });
      }

    case financingActions.FINANCINGS_LIST_GET_SUCCESS: {
      let data = _.sortBy(action.response, (financing) => {
        return financing.closed;
      });
      data = _.filter(data, (financing) => {
        return financing.AssetClass != "ConsumerCredit";
      });

      if (action.financingType == "Issued") {
        return Object.assign({}, state, {
          financingsIssued: Object.assign({}, state.financingsIssued, {
            fetching: false,
            fetched: true,
            data,
          }),
        });
      } else if (action.financingType == "Ready") {
        return Object.assign({}, state, {
          financingsReady: Object.assign({}, state.financingsReady, {
            fetching: false,
            fetched: true,
            data,
          }),
        });
      } else {
        return Object.assign({}, state, {
          financings: Object.assign({}, state.financings, {
            fetching: false,
            fetched: true,
            data,
          }),
        });
      }
    }

    case financingActions.FINANCINGS_LIST_GET_ERROR:
      if (action.financingType == "Issued") {
        return Object.assign({}, state, {
          financingsIssued: Object.assign({}, state.financingsIssued, {
            fetching: false,
            error: action.error,
          }),
        });
      } else if (action.financingType == "Ready") {
        return Object.assign({}, state, {
          financingsReady: Object.assign({}, state.financingsReady, {
            fetching: false,
            error: action.error,
          }),
        });
      } else {
        return Object.assign({}, state, {
          financings: Object.assign({}, state.financings, {
            fetching: false,
            error: action.error,
          }),
        });
      }

    case actions.MPL_FINANCING_LIST_CHANGE_PAGE:
      if (action.financingType == "Issued") {
        return Object.assign({}, state, {
          financingsIssued: Object.assign({}, state.financingsIssued, {
            table: Object.assign({}, state.financingsIssued.table, {
              pagination: Object.assign(
                {},
                state.financingsIssued.table.pagination,
                {
                  page: action.page,
                },
              ),
            }),
          }),
        });
      } else if (action.financingType == "Ready") {
        return Object.assign({}, state, {
          financingsReady: Object.assign({}, state.financingsReady, {
            table: Object.assign({}, state.financingsReady.table, {
              pagination: Object.assign(
                {},
                state.financingsReady.table.pagination,
                {
                  page: action.page,
                },
              ),
            }),
          }),
        });
      } else {
        return Object.assign({}, state, {
          financings: Object.assign({}, state.financings, {
            table: Object.assign({}, state.financings.table, {
              pagination: Object.assign({}, state.financings.table.pagination, {
                page: action.page,
              }),
            }),
          }),
        });
      }

    case actions.MPL_FINANCING_LIST_CHANGE_FILTER:
      if (action.financingType == "Issued") {
        return Object.assign({}, state, {
          financingsIssued: Object.assign({}, state.financingsIssued, {
            table: Object.assign({}, state.financingsIssued.table, {
              currentFilter: Object.assign(
                {},
                state.financingsIssued.table.currentFilter,
                {
                  ...action.filter,
                },
              ),
            }),
          }),
        });
      } else if (action.financingType == "Ready") {
        return Object.assign({}, state, {
          financingsReady: Object.assign({}, state.financingsReady, {
            table: Object.assign({}, state.financingsReady.table, {
              currentFilter: Object.assign(
                {},
                state.financingsReady.table.currentFilter,
                {
                  ...action.filter,
                },
              ),
            }),
          }),
        });
      } else {
        return Object.assign({}, state, {
          financings: Object.assign({}, state.financings, {
            table: Object.assign({}, state.financings.table, {
              currentFilter: Object.assign(
                {},
                state.financings.table.currentFilter,
                {
                  ...action.filter,
                },
              ),
            }),
          }),
        });
      }

    case actions.MPL_FINANCING_CLOSE_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financings.data, (item) => {
        return item.IntId == id;
      });

      let toChange = Object.assign(
        {},
        state.financings.data[toChangeIndex],
        {},
      );
      toChange.Open = false;

      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          data: [
            ...state.financings.data.slice(0, toChangeIndex),
            toChange,
            ...state.financings.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.MPL_FINANCING_OPEN_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financings.data, (item) => {
        return item.IntId == id;
      });

      let toChange = Object.assign(
        {},
        state.financings.data[toChangeIndex],
        {},
      );
      toChange.Open = true;

      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          data: [
            ...state.financings.data.slice(0, toChangeIndex),
            toChange,
            ...state.financings.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.MPL_FINANCING_UNPUBLISH_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financings.data, (item) => {
        return item.IntId == id;
      });

      let toChange = Object.assign({}, state.financings.data[toChangeIndex]);
      toChange.Published = false;

      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          data: [
            ...state.financings.data.slice(0, toChangeIndex),
            toChange,
            ...state.financings.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.MPL_FINANCING_PUBLISH_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financings.data, (item) => {
        return item.IntId == id;
      });

      let toChange = Object.assign({}, state.financings.data[toChangeIndex]);
      toChange.Published = true;

      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          data: [
            ...state.financings.data.slice(0, toChangeIndex),
            toChange,
            ...state.financings.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }
    // Realising financings
    case actions.MPL_FINANCING_REALISE_REQUEST: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financingsReady.data, (item) => {
        return item.IntId == id;
      });

      let toChange = Object.assign(
        {},
        state.financingsReady.data[toChangeIndex],
      );
      toChange.financingsReleasing = true;

      return Object.assign({}, state, {
        financingsReady: Object.assign({}, state.financingsReady, {
          data: [
            ...state.financingsReady.data.slice(0, toChangeIndex),
            toChange,
            ...state.financingsReady.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.MPL_FINANCING_REALISE_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financingsReady.data, (item) => {
        return item.IntId == id;
      });

      return Object.assign({}, state, {
        financingsReady: Object.assign({}, state.financingsReady, {
          data: [
            ...state.financingsReady.data.slice(0, toChangeIndex),
            ...state.financingsReady.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.MPL_FINANCING_REALISE_ERROR: {
      let id = action.financingId;
      let toChangeIndex = _.findIndex(state.financingsReady.data, (item) => {
        return item.IntId == id;
      });

      let toChange = Object.assign(
        {},
        state.financingsReady.data[toChangeIndex],
      );
      toChange.financingsReleasing = false;
      toChange.financingsError = action.error;

      return Object.assign({}, state, {
        financingsReady: Object.assign({}, state.financingsReady, {
          data: [
            ...state.financingsReady.data.slice(0, toChangeIndex),
            toChange,
            ...state.financingsReady.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.MPL_FINANCING_REGISTER_PAYOUT_SUCCESS: {
      let ids = action.dataSent.FinancingId;
      var data = state.financingsIssued.data.slice();

      ids.forEach((id) => {
        var toChangeIndex = _.findIndex(data, (item) => {
          return item.IntId == id;
        });

        data.splice(toChangeIndex, 1);
      });

      return Object.assign({}, state, {
        financingsIssued: Object.assign({}, state.financingsIssued, {
          data: data,
        }),
      });
    }

    case actions.MPL_FINANCING_REGISTER_PAYOUT_ERROR: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financingsIssued.data, (item) => {
        return item.IntId == id;
      });

      let toChange = Object.assign(
        {},
        state.financingsIssued.data[toChangeIndex],
        {},
      );
      toChange.financingsIssued = action.error;

      return Object.assign({}, state, {
        financingsIssued: Object.assign({}, state.financingsIssued, {
          ...state.financingsIssued.data.slice(0, toChangeIndex),
          toChange,
          ...state.financingsIssued.data.slice(toChangeIndex + 1),
        }),
      });
    }

    default:
      return state;
  }
};

export default mplFinancing;
